import React from 'react';

function CallToAction(props) {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("¡Hola! " + props.message);
    window.open(`https://wa.me/+573187073143?text=${message}`, '_blank');
  };

  return (
    <div className="container" style={{marginTop:'2rem'}}>
      <button onClick={handleWhatsAppClick} className="cta-btn" id = {props.actionId}>
        {props.text || 'Contact Us on WhatsApp'}
      </button>
    </div>
  );
}

export default CallToAction;